import {initWebComponent} from "@/helpers/web-component-helper";
import {getBySelector, hideElementsBySelector} from "@/helpers/element-helper";
import Swipe from "ol-ext/control/Swipe.js";
import {getLayerByName} from "@/helpers/ol/ol-layer-helper.js";

const template = document.createElement('template');
template.innerHTML = `
<h3 class="mt-2 mb-1">Lagen vergelijken</h3>
<p class="dropdown-header pb-0 pl-0">Kies hieronder 2 actieve kaartlagen</p>
<div class="mb-2">
    <select data-type="selectCompareLayer" size="1" class="form-control" id="selectCompareLayerLeft">
        <option>Laag links</option>
    </select>
    <select data-type="selectCompareLayer" size="1" class="form-control" id="selectCompareLayerRight">
        <option>Laag rechts</option>
    </select>
    <div class="row justify-content-center">
        <div class="col-6 pl-1">
            <button data-type="reset" class="btn btn-outline-danger btn-sm btn-block mt-2 text-transform-none">Reset</button>
        </div>
        <div class="col-6 pl-1">
            <button data-type="stop" class="btn btn-outline-danger btn-sm btn-block mt-2 text-transform-none">Stop</button>
        </div>
    </div>
</div>`;

/**
 * @type {LayerMenuCompareComponent}
 */
export class LayerMenuCompareComponent extends HTMLElement{
    constructor(){
        super();
        initWebComponent(this, template);

        const selectCompareLayerLeft = getBySelector('#selectCompareLayerLeft')
        const selectCompareLayerRight = getBySelector('#selectCompareLayerRight')

        this.querySelectorAll('select[data-type="selectCompareLayer"]').forEach((select) => {
            select.addEventListener('change', (e) => {
                if(!window.ctrl) {
                    window.ctrl = new Swipe();
                }

                const left = getLayerByName(selectCompareLayerLeft.value);
                const right = getLayerByName(selectCompareLayerRight.value);

                window.ctrl.removeLayers();

                if(left && right) {
                    map.addControl(window.ctrl);
                    window.ctrl.addLayer(left);
                    window.ctrl.addLayer(right, true);
                } else {
                    map.removeControl(window.ctrl);
                }
            });
        });

        function reset() {
            if(window.ctrl) {
                window.ctrl.removeLayers()
                map.removeControl(window.ctrl);
            }
            selectCompareLayerLeft.selectedIndex = 0;
            selectCompareLayerRight.selectedIndex = 0;
            Array.from(selectCompareLayerLeft.options).forEach(option => option.style.display = '');
            Array.from(selectCompareLayerRight.options).forEach(option => option.style.display = '');
        }

        this.querySelector('button[data-type="reset"]').addEventListener('click', (e) => {
            reset()
        });
        this.querySelector('button[data-type="stop"]').addEventListener('click', (e) => {
            reset()
            hideElementsBySelector('layer-menu-compare');
            getBySelector('ol-slider').firstChild.firstChild.classList.remove('active');
        });

        function updateSelectOptions(sourceSelect, targetSelect) {
            // Show all options first
            Array.from(targetSelect.options).forEach(option => {
                option.style.display = '';
            });

            // Hide the selected option from source in target
            const selectedValue = sourceSelect.value;
            if (selectedValue && selectedValue !== 'Laag links' && selectedValue !== 'Laag rechts') {
                const optionToHide = Array.from(targetSelect.options).find(option => option.value === selectedValue);
                if (optionToHide) {
                    optionToHide.style.display = 'none';
                }
            }
        }

        selectCompareLayerLeft.addEventListener('change', () => {
            updateSelectOptions(selectCompareLayerLeft, selectCompareLayerRight);
        });

        selectCompareLayerRight.addEventListener('change', () => {
            updateSelectOptions(selectCompareLayerRight, selectCompareLayerLeft);
        });
    }
}